module.exports = __webpack_public_path__ + "9968e3e9.woff";